import React from "react";

export const GoogleMapsContext = React.createContext({ isLoaded: false });
